import type { FeatureGroup } from '../../types';

export const PAYMENTS_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0000',
  name: 'payments',
  description: 'Root group for all payments features — transactions, gateways, taking payments, integrations and settings',
  product: 'payments',
};
